import axiosInstance from '../api/axios';

/**
 * Validate a Kajabi/Stripe purchase_key for the create-account unlock flow.
 * Calls the public Cloud Function (no auth required).
 */
export const validatePurchaseKey = async (purchaseKey) => {
  const key = String(purchaseKey || '').trim();
  if (!key) {
    return { valid: false, reason: 'missing', email: null };
  }

  const response = await axiosInstance.post('/validate_purchase_key', {
    purchase_key: key,
  });

  // ResponseFormatter wraps as { success, data: { valid, email } }
  const payload = response.data?.data || response.data || {};
  return {
    valid: payload.valid === true,
    email: payload.email || null,
    reason: payload.reason || null,
  };
};

export default { validatePurchaseKey };
